import React, { Component } from 'react';
import RcSlider from 'rc-slider';
import Range from './range';
import handle from './handle';

import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';

export default class Slider extends Component {
  render() {
    const {
      defaultValue,
      value,
      onChange,
      marks,
      step,
      unit,
      hideStepLabel,
      style,
      trackStyle,
      railStyle,
      activeDotStyle,
      handleStyle
    } = this.props;
    return (
      <div className="slider-wrapper" style={style}>
        <RcSlider
          trackStyle={trackStyle}
          railStyle={railStyle}
          activeDotStyle={activeDotStyle}
          marks={marks}
          handle={props =>
            handle(props, { unit: unit, hideStepLabel: hideStepLabel })
          }
          onChange={onChange}
          defaultValue={defaultValue}
          value={value}
          step={step}
          handleStyle={handleStyle}
        />
      </div>
    );
  }
}

Slider.defaultProps = {
  defaultValue: 0,
  unit: '%',
  step: 1,
  hideStepLabel: false,
  style: {},
  trackStyle: { backgroundColor: '#3a7eea', height: 3 },
  railStyle: { backgroundColor: '#d6dce7', height: 3 },
  activeDotStyle: { borderColor: '#3a7eea' },
  handleStyle: {
    borderColor: '#3a7eea',
    height: 14,
    width: 14,
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0)'
  },
  onChange: () => {}
};

Slider.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hideStepLabel: PropTypes.bool.isRequired,
  marks: PropTypes.object,
  step: PropTypes.number,
  style: PropTypes.object,
  trackStyle: PropTypes.object,
  railStyle: PropTypes.object,
  activeDotStyle: PropTypes.object,
  handleStyle: PropTypes.object
};

Slider.Range = Range;
